import axios from "axios";
import * as PATH from "../helpers/APIURL";

export default class RestaurantService {

    static addRestaurant = data => {
        return axios.post(PATH.ADD_RESTAURANT, data);
    }

    static getRestaurantList = params => {
        return axios.get(PATH.GET_ALL_RESTAURANT, {params});
    }

    //note: personal restaurant list
    static getPersonalRestaurantList = params => {
        return axios.get(PATH.GET_ALL_PERSONAL_RESTAURANT, {params});
    }

    static getRestaurantById = id => {
        return axios.get(`${PATH.GET_RESTAURANT_BY_ID}/${id}`);
    }

    static getPersonalRestaurantById = id => {
        return axios.get(`${PATH.GET_PERSONAL_RESTAURANT_BY_ID}/${id}`);
    }

    static getRestaurantProfile = () => {
        return axios.get(PATH.GET_RESTAURANT_PROFILE);
    }

    static editRestaurantProfile = data => {
        return axios.put(PATH.EDIT_RESTAURANT_PROFILE, data);
    }

    static editRestaurant = (data, id) => {
        return axios.put(`${PATH.EDIT_RESTAURANT}/${id}`, data);
    }

    static editPersonalRestaurant = (data, id) => {
        return axios.put(`${PATH.EDIT_PERSONAL_RESTAURANT}/${id}`, data);
    }

}
